import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginPage from './LoginPage';
import UsernameSetup from './UsernameSetup';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireUsername?: boolean;
}

const LoadingScreen: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center" style={{
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  }}>
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '48px 32px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      textAlign: 'center'
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '4px solid #e5e7eb',
        borderTop: '4px solid #3b82f6',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 16px'
      }} />
      <p style={{
        color: '#6b7280',
        fontSize: '16px'
      }}>
        Loading...
      </p>
    </div>
    
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireUsername = true 
}) => {
  const { user, loading } = useAuth();

  // Show loading screen while checking authentication
  if (loading) {
    return <LoadingScreen />;
  }

  // Show login page if not authenticated
  if (!user) {
    return <LoginPage />;
  }

  // Show username setup for first-time users
  if (requireUsername && user.isFirstTime && !user.username) {
    return <UsernameSetup />;
  }

  // User is authenticated and has completed setup
  return <>{children}</>;
};

export default ProtectedRoute;